export default {
  $validator: (value) => {
    return value === utilities.getUrlSafeString(value);
  },
};
